import React, { FC, memo, useEffect, useRef } from 'react'

import { QrCodeProps } from '@/types/componentsPropsTypes'
import { generateQrCode } from '@/utils/utils'

const QrCodeRaw: FC<QrCodeProps> = ({ qrPath, qrSize }) => {
  const qrCode = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    qrPath && qrCode.current && generateQrCode(qrPath, qrCode.current, qrSize)
  }, [qrPath, qrCode.current])

  return <canvas ref={qrCode} />
}

export const QrCode = memo(QrCodeRaw)
